import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { SkillDetailsFragmentDoc } from '../../../../../../../../../graphql/fragment/generated/SkillDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MicroSkillFragment = { id: string, name: string, childrenIds?: Array<string> | null, parentIds?: Array<string> | null };


export type MicroSkillFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type SkillWithMicroSkillDetailsFragment = { __typename: 'SkillType', childrenIds?: Array<string> | null, id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, childSkills?: Array<{ id: string, name: string, childrenIds?: Array<string> | null, parentIds?: Array<string> | null }> | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null };


export type SkillWithMicroSkillDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type SkillMicroSkillDetailsQueryVariables = Types.Exact<{
  filters: Types.GetByIdFilter;
}>;


export type SkillMicroSkillDetailsQuery = { skill?: { __typename: 'SkillType', childrenIds?: Array<string> | null, id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, childSkills?: Array<{ id: string, name: string, childrenIds?: Array<string> | null, parentIds?: Array<string> | null }> | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null } | null };

export const MicroSkillFragmentDoc = /*#__PURE__*/ gql`
    fragment MicroSkill on SkillType {
  id
  name
  childrenIds
  parentIds
}
    `;
export const SkillWithMicroSkillDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment SkillWithMicroSkillDetails on SkillType {
  ...SkillDetails
  childrenIds
  childSkills {
    ...MicroSkill
  }
}
    `;
export const SkillMicroSkillDetailsDocument = /*#__PURE__*/ gql`
    query skillMicroSkillDetails($filters: GetByIdFilter!) {
  skill(filters: $filters) {
    ...SkillWithMicroSkillDetails
  }
}
    ${SkillWithMicroSkillDetailsFragmentDoc}
${SkillDetailsFragmentDoc}
${MicroSkillFragmentDoc}`;

export function useSkillMicroSkillDetailsQuery(options: Omit<Urql.UseQueryArgs<SkillMicroSkillDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<SkillMicroSkillDetailsQuery, SkillMicroSkillDetailsQueryVariables>({ query: SkillMicroSkillDetailsDocument, ...options });
};